import { Link } from "react-router-dom";

function Home() {
    return (
        <header>
            <h1 className="title is-size-one has-text-centered">Countries API</h1>

            <h2 className="subtitle is-size-two">Links</h2>

            <ul>
                <li className="my-4"><h3 className="subtitle is-size-three">Data listings</h3></li>
                <li><Link to="/all">JSON list of all the data.</Link></li>
                <li><Link to="/Finland">JSON list of a single country</Link>, in this case Finland.</li>
                <ul>
                    <li>You can go up to five levels deep. If the data you want is not found, you will be notified about it &mdash; alternatively, you get an empty data set. Therefore something like <Link to="/Finland/name/nativeName/fin/common">/Finland/name/nativeName/fin/common</Link> is possible.</li>
                </ul>
                <li>This is not a pure data response, since it is shown on a web page for illustrative purposes to show that it indeed works. The change, however, would be trivial. Neither does it fetch data from another web site (see below for the original data site). This is in order to prevent using their bandwidth for my project.</li>

                <li className="my-4"><h3 className="subtitle is-size-three">Graphical representations</h3></li>
                <li><Link to="/view">List of all countries, selectable links.</Link></li>
                <li><Link to="/view/Finland">A list of some of Finland's data, formatted</Link>. All the other countries follow the same pattern.</li>

                <li className="my-4"><h3 className="subtitle is-size-three">Custom data</h3></li>
                <li>Capitals <Link to="/capitals">JSON</Link> - Returns an array (one country may have more than one capital).</li>
                <li>Continents <Link to="/continents">JSON</Link></li>
                
                <li className="my-4"><h4 className="subtitle is-size-6">Countries by continent</h4></li>
                <ul>
                    <li>Africa <Link to="/continents/Africa/countries">JSON</Link> | <Link to="/view/continents/Africa/countries">View</Link></li>
                    <li>Americas <Link to="/continents/Americas/countries">JSON</Link> | <Link to="/view/continents/Americas/countries">View</Link></li>
                    <li>Antarctic <Link to="/continents/Antarctic/countries">JSON</Link> | <Link to="/view/continents/Antarctic/countries">View</Link></li>
                    <li>Asia <Link to="/continents/Asia/countries">JSON</Link> | <Link to="/view/continents/Asia/countries">View</Link></li>
                    <li>Europe <Link to="/continents/Europe/countries">JSON</Link> | <Link to="/view/continents/Europe/countries">View</Link></li>
                    <li>Oceania <Link to="/continents/Oceania/countries">JSON</Link> | <Link to="/view/continents/Oceania/countries">View</Link></li>
                </ul>

                <li className="my-4"><h4 className="susbtitle is-size-6">Flags</h4></li>
                <ul>
                    <li>All flags <Link to="/flags">JSON</Link></li>
                    <li>Country flag <Link to="/Finland/flag">JSON</Link>. Finland as an example - you can replace Finland with <Link to="/view">these names</Link>.</li>
                </ul>

                <li className="my-4"><h4 className="subtitle is-size-6">Largest</h4></li>
                <ul>
                    <li>Largest countries by area <Link to="/countries/largest/area">JSON</Link></li>
                    <li>Largest countries by population <Link to="/countries/largest/population">JSON</Link></li>
                </ul>

                <li className="my-4"><h4 className="subtitle is-size-6">Smallest</h4></li>
                <ul>
                    <li>Smallest countries by area <Link to="/countries/smallest/area">JSON</Link></li>
                    <li>Smallest countries by population <Link to="/countries/smallest/population">JSON</Link></li>
                </ul>
            </ul>

            <p className="my-4">
                All the (modified) data here is from <a href="https://restcountries.com/">REST COUNTRIES</a>, v3.1 API endpoint to be more specific. The site and its data, and therefore this web app since this uses the data from that site, follow the <a href="https://www.mozilla.org/en-US/MPL/2.0/" target="noreferrer nofollow">Mozilla Public License</a> Version 2.0.
            </p>
        </header>
    )
}

export default Home;